(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlinx-serialization-kotlinx-serialization-core.js', './kotlin-kotlin-stdlib.js', './fixers-s2-s2-automate-s2-automate-dsl.js', './fixers-f2-f2-dsl-f2-dsl-cqrs.js', './boislocal-platform-platform-infra-commons-commons-domain.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./kotlin-kotlin-stdlib.js'), require('./fixers-s2-s2-automate-s2-automate-dsl.js'), require('./fixers-f2-f2-dsl-f2-dsl-cqrs.js'), require('./boislocal-platform-platform-infra-commons-commons-domain.js'));
  else {
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-referential-realizationCertification-realizationCertification-domain'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'boislocal-platform-platform-s2-referential-realizationCertification-realizationCertification-domain'.");
    }
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-referential-realizationCertification-realizationCertification-domain'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'boislocal-platform-platform-s2-referential-realizationCertification-realizationCertification-domain'.");
    }
    if (typeof this['fixers-s2-s2-automate-s2-automate-dsl'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-referential-realizationCertification-realizationCertification-domain'. Its dependency 'fixers-s2-s2-automate-s2-automate-dsl' was not found. Please, check whether 'fixers-s2-s2-automate-s2-automate-dsl' is loaded prior to 'boislocal-platform-platform-s2-referential-realizationCertification-realizationCertification-domain'.");
    }
    if (typeof this['fixers-f2-f2-dsl-f2-dsl-cqrs'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-referential-realizationCertification-realizationCertification-domain'. Its dependency 'fixers-f2-f2-dsl-f2-dsl-cqrs' was not found. Please, check whether 'fixers-f2-f2-dsl-f2-dsl-cqrs' is loaded prior to 'boislocal-platform-platform-s2-referential-realizationCertification-realizationCertification-domain'.");
    }
    if (typeof this['boislocal-platform-platform-infra-commons-commons-domain'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-referential-realizationCertification-realizationCertification-domain'. Its dependency 'boislocal-platform-platform-infra-commons-commons-domain' was not found. Please, check whether 'boislocal-platform-platform-infra-commons-commons-domain' is loaded prior to 'boislocal-platform-platform-s2-referential-realizationCertification-realizationCertification-domain'.");
    }
    root['boislocal-platform-platform-s2-referential-realizationCertification-realizationCertification-domain'] = factory(typeof this['boislocal-platform-platform-s2-referential-realizationCertification-realizationCertification-domain'] === 'undefined' ? {} : this['boislocal-platform-platform-s2-referential-realizationCertification-realizationCertification-domain'], this['kotlinx-serialization-kotlinx-serialization-core'], this['kotlin-kotlin-stdlib'], this['fixers-s2-s2-automate-s2-automate-dsl'], this['fixers-f2-f2-dsl-f2-dsl-cqrs'], this['boislocal-platform-platform-infra-commons-commons-domain']);
  }
}(this, function (_, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_kotlin, kotlin_io_komune_s2_s2_automate_dsl, kotlin_io_komune_f2_f2_dsl_cqrs, kotlin_org_boislocal_commons_domain) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var createSimpleEnumSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c2;
  var LazyThreadSafetyMode_PUBLICATION_getInstance = kotlin_kotlin.$_$.i;
  var lazy = kotlin_kotlin.$_$.ge;
  var protoOf = kotlin_kotlin.$_$.fa;
  var SerializerFactory = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b2;
  var objectMeta = kotlin_kotlin.$_$.ea;
  var setMetadataFor = kotlin_kotlin.$_$.ga;
  var VOID = kotlin_kotlin.$_$.g;
  var THROW_IAE = kotlin_kotlin.$_$.ld;
  var Unit_instance = kotlin_kotlin.$_$.t4;
  var Enum = kotlin_kotlin.$_$.zc;
  var defineProp = kotlin_kotlin.$_$.b9;
  var S2State = kotlin_io_komune_s2_s2_automate_dsl.$_$.j;
  var classMeta = kotlin_kotlin.$_$.z8;
  var S2TransitionBuilder = kotlin_io_komune_s2_s2_automate_dsl.$_$.b;
  var toValue = kotlin_io_komune_s2_s2_automate_dsl.$_$.m;
  var toValue_0 = kotlin_io_komune_s2_s2_automate_dsl.$_$.n;
  var getKClass = kotlin_kotlin.$_$.f;
  var toValue_1 = kotlin_io_komune_s2_s2_automate_dsl.$_$.l;
  var S2Transition = kotlin_io_komune_s2_s2_automate_dsl.$_$.k;
  var S2SelfTransitionBuilder = kotlin_io_komune_s2_s2_automate_dsl.$_$.a;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.j5;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.k;
  var s2Sourcing = kotlin_io_komune_s2_s2_automate_dsl.$_$.c;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z1;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e;
  var THROW_CCE = kotlin_kotlin.$_$.kd;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u1;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v1;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e2;
  var objectCreate = kotlin_kotlin.$_$.da;
  var S2Role = kotlin_io_komune_s2_s2_automate_dsl.$_$.i;
  var S2InitCommand = kotlin_io_komune_s2_s2_automate_dsl.$_$.h;
  var interfaceMeta = kotlin_kotlin.$_$.k9;
  var WithS2Id = kotlin_io_komune_s2_s2_automate_dsl.$_$.e;
  var Event = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.d;
  var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v;
  var getStringHashCode = kotlin_kotlin.$_$.i9;
  var $serializer_getInstance = kotlin_org_boislocal_commons_domain.$_$.g;
  var LongSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q;
  var toString = kotlin_kotlin.$_$.le;
  var equals = kotlin_kotlin.$_$.c9;
  var S2Command = kotlin_io_komune_s2_s2_automate_dsl.$_$.g;
  var Long = kotlin_kotlin.$_$.ed;
  var WithS2State = kotlin_io_komune_s2_s2_automate_dsl.$_$.f;
  var Roles_instance = kotlin_org_boislocal_commons_domain.$_$.b;
  var hasRole = kotlin_org_boislocal_commons_domain.$_$.m;
  var ensureNotNull = kotlin_kotlin.$_$.be;
  var isAvailableTransition = kotlin_io_komune_s2_s2_automate_dsl.$_$.d;
  var Query = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.e;
  var PageQueryDTO = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.a;
  var PageQueryResultDTO = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.b;
  //endregion
  //region block: pre-declaration
  setMetadataFor(Companion, 'Companion', objectMeta, VOID, [SerializerFactory]);
  setMetadataFor(RealizationCertificationState, 'RealizationCertificationState', classMeta, Enum, [Enum, S2State], VOID, VOID, {0: Companion_getInstance});
  setMetadataFor(S2, 'S2', objectMeta);
  setMetadataFor(UserRole, 'UserRole', classMeta, VOID, [S2Role], VOID, VOID, {0: $serializer_getInstance_0});
  setMetadataFor(User, 'User', objectMeta, UserRole);
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor($serializer, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RealizationCertificationCreateCommandDTO, 'RealizationCertificationCreateCommandDTO', interfaceMeta, VOID, [S2InitCommand]);
  setMetadataFor(RealizationCertificationCreatedEventDTO, 'RealizationCertificationCreatedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_1, 'Companion', objectMeta);
  setMetadataFor($serializer_0, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RealizationCertificationCreateCommand, 'RealizationCertificationCreateCommand', classMeta, VOID, [RealizationCertificationCreateCommandDTO], VOID, VOID, {0: $serializer_getInstance_1});
  setMetadataFor(Companion_2, 'Companion', objectMeta);
  setMetadataFor($serializer_1, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RealizationCertificationCreatedEvent, 'RealizationCertificationCreatedEvent', classMeta, VOID, [RealizationCertificationCreatedEventDTO], VOID, VOID, {0: $serializer_getInstance_2});
  setMetadataFor(RealizationCertificationDeleteCommandDTO, 'RealizationCertificationDeleteCommandDTO', interfaceMeta, VOID, [S2Command]);
  setMetadataFor(RealizationCertificationDeletedEventDTO, 'RealizationCertificationDeletedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_3, 'Companion', objectMeta);
  setMetadataFor($serializer_2, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RealizationCertificationDeleteCommand, 'RealizationCertificationDeleteCommand', classMeta, VOID, [RealizationCertificationDeleteCommandDTO], VOID, VOID, {0: $serializer_getInstance_3});
  setMetadataFor(Companion_4, 'Companion', objectMeta);
  setMetadataFor($serializer_3, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RealizationCertificationDeletedEvent, 'RealizationCertificationDeletedEvent', classMeta, VOID, [RealizationCertificationDeletedEventDTO], VOID, VOID, {0: $serializer_getInstance_4});
  setMetadataFor(RealizationCertificationImportCommandDTO, 'RealizationCertificationImportCommandDTO', interfaceMeta, VOID, [S2InitCommand]);
  setMetadataFor(RealizationCertificationImportedEventDTO, 'RealizationCertificationImportedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_5, 'Companion', objectMeta);
  setMetadataFor($serializer_4, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RealizationCertificationImportCommand, 'RealizationCertificationImportCommand', classMeta, VOID, [RealizationCertificationImportCommandDTO], VOID, VOID, {0: $serializer_getInstance_5});
  setMetadataFor(Companion_6, 'Companion', objectMeta);
  setMetadataFor($serializer_5, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RealizationCertificationImportedEvent, 'RealizationCertificationImportedEvent', classMeta, VOID, [RealizationCertificationImportedEventDTO], VOID, VOID, {0: $serializer_getInstance_6});
  setMetadataFor(RealizationCertificationUpdateCommandDTO, 'RealizationCertificationUpdateCommandDTO', interfaceMeta, VOID, [S2Command]);
  setMetadataFor(RealizationCertificationUpdatedEventDTO, 'RealizationCertificationUpdatedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_7, 'Companion', objectMeta);
  setMetadataFor($serializer_6, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RealizationCertificationUpdateCommand, 'RealizationCertificationUpdateCommand', classMeta, VOID, [RealizationCertificationUpdateCommandDTO], VOID, VOID, {0: $serializer_getInstance_7});
  setMetadataFor(Companion_8, 'Companion', objectMeta);
  setMetadataFor($serializer_7, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RealizationCertificationUpdatedEvent, 'RealizationCertificationUpdatedEvent', classMeta, VOID, [RealizationCertificationUpdatedEventDTO], VOID, VOID, {0: $serializer_getInstance_8});
  setMetadataFor(RealizationCertificationModelDTO, 'RealizationCertificationModelDTO', interfaceMeta, VOID, [WithS2State, WithS2Id]);
  setMetadataFor(Companion_9, 'Companion', objectMeta);
  setMetadataFor($serializer_8, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(RealizationCertificationModel, 'RealizationCertificationModel', classMeta, VOID, [RealizationCertificationModelDTO], VOID, VOID, {0: $serializer_getInstance_9});
  setMetadataFor(RealizationCertificationPolicies, 'RealizationCertificationPolicies', objectMeta);
  setMetadataFor(RealizationCertificationGetQueryDTO, 'RealizationCertificationGetQueryDTO', interfaceMeta, VOID, [Query]);
  setMetadataFor(RealizationCertificationGetResponseDTO, 'RealizationCertificationGetResponseDTO', interfaceMeta);
  setMetadataFor(RealizationCertificationPageQueryDTO, 'RealizationCertificationPageQueryDTO', interfaceMeta, VOID, [PageQueryDTO]);
  setMetadataFor(RealizationCertificationPageResponseDTO, 'RealizationCertificationPageResponseDTO', interfaceMeta, VOID, [PageQueryResultDTO]);
  //endregion
  function _get_$cachedSerializer__te6jhj($this) {
    return $this.o2y_1.f2();
  }
  function RealizationCertificationState$Companion$_anonymous__r81er6() {
    return createSimpleEnumSerializer('org.boislocal.platform.s2.realizationCertification.domain.automate.RealizationCertificationState', values());
  }
  var RealizationCertificationState_Exists_instance;
  var RealizationCertificationState_Deleted_instance;
  function Companion() {
    Companion_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.o2y_1 = lazy(tmp_0, RealizationCertificationState$Companion$_anonymous__r81er6);
  }
  protoOf(Companion).x14 = function () {
    return _get_$cachedSerializer__te6jhj(this);
  };
  protoOf(Companion).hu = function (typeParamsSerializers) {
    return this.x14();
  };
  var Companion_instance;
  function Companion_getInstance() {
    RealizationCertificationState_initEntries();
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function values() {
    return [RealizationCertificationState_Exists_getInstance(), RealizationCertificationState_Deleted_getInstance()];
  }
  function valueOf(value) {
    switch (value) {
      case 'Exists':
        return RealizationCertificationState_Exists_getInstance();
      case 'Deleted':
        return RealizationCertificationState_Deleted_getInstance();
      default:
        RealizationCertificationState_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var RealizationCertificationState_entriesInitialized;
  function RealizationCertificationState_initEntries() {
    if (RealizationCertificationState_entriesInitialized)
      return Unit_instance;
    RealizationCertificationState_entriesInitialized = true;
    RealizationCertificationState_Exists_instance = new RealizationCertificationState('Exists', 0, 0);
    RealizationCertificationState_Deleted_instance = new RealizationCertificationState('Deleted', 1, 1);
    Companion_getInstance();
  }
  function RealizationCertificationState(name, ordinal, position) {
    Enum.call(this, name, ordinal);
    this.r2y_1 = position;
  }
  protoOf(RealizationCertificationState).y2c = function (_set____db54di) {
    this.r2y_1 = _set____db54di;
  };
  protoOf(RealizationCertificationState).jr = function () {
    return this.r2y_1;
  };
  function S2$realizationCertificationAutomate$lambda($this$s2Sourcing) {
    $this$s2Sourcing.j27_1 = 'RealizationCertification';
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.realizationCertification.domain.automate.S2.realizationCertificationAutomate.<anonymous>.<anonymous>' call
    builder.o27_1 = RealizationCertificationState_Exists_getInstance();
    builder.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver = builder.m27_1;
    var tmp = tmp0_safe_receiver == null ? null : toValue(tmp0_safe_receiver);
    var tmp_0 = toValue(builder.c24());
    var tmp_1 = toValue_0(builder.d24());
    var tmp_2 = toValue_1(getKClass(RealizationCertificationImportCommand));
    var tmp1_elvis_lhs = builder.q27_1;
    var this_0 = new S2Transition(tmp, tmp_0, tmp_1, tmp_2, toValue_1(tmp1_elvis_lhs == null ? getKClass(RealizationCertificationImportedEvent) : tmp1_elvis_lhs));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_0);
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder_0 = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.realizationCertification.domain.automate.S2.realizationCertificationAutomate.<anonymous>.<anonymous>' call
    builder_0.o27_1 = RealizationCertificationState_Deleted_getInstance();
    builder_0.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_0 = builder_0.m27_1;
    var tmp_3 = tmp0_safe_receiver_0 == null ? null : toValue(tmp0_safe_receiver_0);
    var tmp_4 = toValue(builder_0.c24());
    var tmp_5 = toValue_0(builder_0.d24());
    var tmp_6 = toValue_1(getKClass(RealizationCertificationImportCommand));
    var tmp1_elvis_lhs_0 = builder_0.q27_1;
    var this_1 = new S2Transition(tmp_3, tmp_4, tmp_5, tmp_6, toValue_1(tmp1_elvis_lhs_0 == null ? getKClass(RealizationCertificationImportedEvent) : tmp1_elvis_lhs_0));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_1);
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder_1 = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.realizationCertification.domain.automate.S2.realizationCertificationAutomate.<anonymous>.<anonymous>' call
    builder_1.o27_1 = RealizationCertificationState_Exists_getInstance();
    builder_1.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_1 = builder_1.m27_1;
    var tmp_7 = tmp0_safe_receiver_1 == null ? null : toValue(tmp0_safe_receiver_1);
    var tmp_8 = toValue(builder_1.c24());
    var tmp_9 = toValue_0(builder_1.d24());
    var tmp_10 = toValue_1(getKClass(RealizationCertificationCreateCommand));
    var tmp1_elvis_lhs_1 = builder_1.q27_1;
    var this_2 = new S2Transition(tmp_7, tmp_8, tmp_9, tmp_10, toValue_1(tmp1_elvis_lhs_1 == null ? getKClass(RealizationCertificationCreatedEvent) : tmp1_elvis_lhs_1));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_2);
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.selfTransaction' call
    var builder_2 = new S2SelfTransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.realizationCertification.domain.automate.S2.realizationCertificationAutomate.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.collections.plusAssign' call
    var this_3 = builder_2.r27_1;
    var element = RealizationCertificationState_Exists_getInstance();
    this_3.r(element);
    builder_2.s27_1 = User_getInstance();
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.map' call
    var this_4 = builder_2.r27_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_4, 10));
    var tmp0_iterator = this_4.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.w();
      // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.selfTransaction.<anonymous>' call
      var tmp_11 = toValue(item);
      var tmp_12 = toValue(item);
      var tmp_13 = toValue_0(builder_2.d24());
      var tmp_14 = toValue_1(getKClass(RealizationCertificationUpdateCommand));
      var tmp0_elvis_lhs = builder_2.t27_1;
      var tmp$ret$6 = new S2Transition(tmp_11, tmp_12, tmp_13, tmp_14, toValue_1(tmp0_elvis_lhs == null ? getKClass(RealizationCertificationUpdatedEvent) : tmp0_elvis_lhs));
      destination.r(tmp$ret$6);
    }
    var tmp3_forEach_receiver = $this$s2Sourcing.l27_1;
    var tmp0_iterator_0 = destination.u();
    while (tmp0_iterator_0.v()) {
      var element_0 = tmp0_iterator_0.w();
      invoke$add(tmp3_forEach_receiver, element_0);
    }
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder_3 = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.realizationCertification.domain.automate.S2.realizationCertificationAutomate.<anonymous>.<anonymous>' call
    builder_3.m27_1 = RealizationCertificationState_Exists_getInstance();
    builder_3.o27_1 = RealizationCertificationState_Deleted_getInstance();
    builder_3.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_2 = builder_3.m27_1;
    var tmp_15 = tmp0_safe_receiver_2 == null ? null : toValue(tmp0_safe_receiver_2);
    var tmp_16 = toValue(builder_3.c24());
    var tmp_17 = toValue_0(builder_3.d24());
    var tmp_18 = toValue_1(getKClass(RealizationCertificationDeleteCommand));
    var tmp1_elvis_lhs_2 = builder_3.q27_1;
    var this_5 = new S2Transition(tmp_15, tmp_16, tmp_17, tmp_18, toValue_1(tmp1_elvis_lhs_2 == null ? getKClass(RealizationCertificationDeletedEvent) : tmp1_elvis_lhs_2));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_5);
    return Unit_instance;
  }
  function invoke$add(receiver, p0) {
    receiver.r(p0);
  }
  function S2() {
    S2_instance = this;
    var tmp = this;
    tmp.s2y_1 = s2Sourcing(S2$realizationCertificationAutomate$lambda);
  }
  var S2_instance;
  function S2_getInstance() {
    if (S2_instance == null)
      new S2();
    return S2_instance;
  }
  function User() {
    User_instance = this;
    UserRole.call(this, 'User');
  }
  var User_instance;
  function User_getInstance() {
    if (User_instance == null)
      new User();
    return User_instance;
  }
  function Companion_0() {
  }
  var Companion_instance_0;
  function Companion_getInstance_0() {
    return Companion_instance_0;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.realizationCertification.domain.automate.UserRole', this, 1);
    tmp0_serialDesc.ht('name', false);
    this.u2y_1 = tmp0_serialDesc;
  }
  protoOf($serializer).ii = function () {
    return this.u2y_1;
  };
  protoOf($serializer).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  protoOf($serializer).ki = function (decoder) {
    var tmp0_desc = this.u2y_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.ul(tmp0_desc);
    if (tmp5_input.km()) {
      tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.vl(tmp0_desc);
    return UserRole_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer).v2y = function (encoder, value) {
    var tmp0_desc = this.u2y_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.h9());
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer).ji = function (encoder, value) {
    return this.v2y(encoder, value instanceof UserRole ? value : THROW_CCE());
  };
  var $serializer_instance;
  function $serializer_getInstance_0() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function UserRole_init_$Init$(seen1, name, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_0().u2y_1);
    }
    $this.t2y_1 = name;
    return $this;
  }
  function UserRole_init_$Create$(seen1, name, serializationConstructorMarker) {
    return UserRole_init_$Init$(seen1, name, serializationConstructorMarker, objectCreate(protoOf(UserRole)));
  }
  function UserRole(name) {
    this.t2y_1 = name;
  }
  protoOf(UserRole).h9 = function () {
    return this.t2y_1;
  };
  protoOf(UserRole).toString = function () {
    return this.h9();
  };
  function RealizationCertificationState_Exists_getInstance() {
    RealizationCertificationState_initEntries();
    return RealizationCertificationState_Exists_instance;
  }
  function RealizationCertificationState_Deleted_getInstance() {
    RealizationCertificationState_initEntries();
    return RealizationCertificationState_Deleted_instance;
  }
  function RealizationCertificationCreateCommandDTO() {
  }
  function RealizationCertificationCreatedEventDTO() {
  }
  function Companion_1() {
  }
  var Companion_instance_1;
  function Companion_getInstance_1() {
    return Companion_instance_1;
  }
  function $serializer_0() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.realizationCertification.domain.command.RealizationCertificationCreateCommand', this, 2);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('img', false);
    this.w2y_1 = tmp0_serialDesc;
  }
  protoOf($serializer_0).ii = function () {
    return this.w2y_1;
  };
  protoOf($serializer_0).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  protoOf($serializer_0).ki = function (decoder) {
    var tmp0_desc = this.w2y_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.ul(tmp0_desc);
    if (tmp6_input.km()) {
      tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.im(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.im(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.vl(tmp0_desc);
    return RealizationCertificationCreateCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_0).x2y = function (encoder, value) {
    var tmp0_desc = this.w2y_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.y2y_1);
    tmp1_output.nn(tmp0_desc, 1, StringSerializer_getInstance(), value.z2y_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_0).ji = function (encoder, value) {
    return this.x2y(encoder, value instanceof RealizationCertificationCreateCommand ? value : THROW_CCE());
  };
  var $serializer_instance_0;
  function $serializer_getInstance_1() {
    if ($serializer_instance_0 == null)
      new $serializer_0();
    return $serializer_instance_0;
  }
  function RealizationCertificationCreateCommand_init_$Init$(seen1, name, img, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_1().w2y_1);
    }
    $this.y2y_1 = name;
    $this.z2y_1 = img;
    return $this;
  }
  function RealizationCertificationCreateCommand_init_$Create$(seen1, name, img, serializationConstructorMarker) {
    return RealizationCertificationCreateCommand_init_$Init$(seen1, name, img, serializationConstructorMarker, objectCreate(protoOf(RealizationCertificationCreateCommand)));
  }
  function RealizationCertificationCreateCommand(name, img) {
    this.y2y_1 = name;
    this.z2y_1 = img;
  }
  protoOf(RealizationCertificationCreateCommand).h9 = function () {
    return this.y2y_1;
  };
  protoOf(RealizationCertificationCreateCommand).d2d = function () {
    return this.z2y_1;
  };
  protoOf(RealizationCertificationCreateCommand).toString = function () {
    return 'RealizationCertificationCreateCommand(name=' + this.y2y_1 + ', img=' + this.z2y_1 + ')';
  };
  protoOf(RealizationCertificationCreateCommand).hashCode = function () {
    var result = getStringHashCode(this.y2y_1);
    result = imul(result, 31) + (this.z2y_1 == null ? 0 : getStringHashCode(this.z2y_1)) | 0;
    return result;
  };
  protoOf(RealizationCertificationCreateCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RealizationCertificationCreateCommand))
      return false;
    var tmp0_other_with_cast = other instanceof RealizationCertificationCreateCommand ? other : THROW_CCE();
    if (!(this.y2y_1 === tmp0_other_with_cast.y2y_1))
      return false;
    if (!(this.z2y_1 == tmp0_other_with_cast.z2y_1))
      return false;
    return true;
  };
  function Companion_2() {
  }
  var Companion_instance_2;
  function Companion_getInstance_2() {
    return Companion_instance_2;
  }
  function $serializer_1() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RealizationCertificationCreatedEvent', this, 4);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('img', false);
    tmp0_serialDesc.ht('time', false);
    this.a2z_1 = tmp0_serialDesc;
  }
  protoOf($serializer_1).ii = function () {
    return this.a2z_1;
  };
  protoOf($serializer_1).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable($serializer_getInstance()), get_nullable(LongSerializer_getInstance())];
  };
  protoOf($serializer_1).ki = function (decoder) {
    var tmp0_desc = this.a2z_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.ul(tmp0_desc);
    if (tmp8_input.km()) {
      tmp4_local0 = tmp8_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.em(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.im(tmp0_desc, 2, $serializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.im(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.em(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.im(tmp0_desc, 2, $serializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.im(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.vl(tmp0_desc);
    return RealizationCertificationCreatedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_1).b2z = function (encoder, value) {
    var tmp0_desc = this.a2z_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.c2z_1);
    tmp1_output.jn(tmp0_desc, 1, value.d2z_1);
    tmp1_output.nn(tmp0_desc, 2, $serializer_getInstance(), value.e2z_1);
    tmp1_output.nn(tmp0_desc, 3, LongSerializer_getInstance(), value.f2z_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_1).ji = function (encoder, value) {
    return this.b2z(encoder, value instanceof RealizationCertificationCreatedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_1;
  function $serializer_getInstance_2() {
    if ($serializer_instance_1 == null)
      new $serializer_1();
    return $serializer_instance_1;
  }
  function RealizationCertificationCreatedEvent_init_$Init$(seen1, id, name, img, time, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen1))) {
      throwMissingFieldException(seen1, 15, $serializer_getInstance_2().a2z_1);
    }
    $this.c2z_1 = id;
    $this.d2z_1 = name;
    $this.e2z_1 = img;
    $this.f2z_1 = time;
    return $this;
  }
  function RealizationCertificationCreatedEvent_init_$Create$(seen1, id, name, img, time, serializationConstructorMarker) {
    return RealizationCertificationCreatedEvent_init_$Init$(seen1, id, name, img, time, serializationConstructorMarker, objectCreate(protoOf(RealizationCertificationCreatedEvent)));
  }
  function RealizationCertificationCreatedEvent(id, name, img, time) {
    this.c2z_1 = id;
    this.d2z_1 = name;
    this.e2z_1 = img;
    this.f2z_1 = time;
  }
  protoOf(RealizationCertificationCreatedEvent).k1y = function () {
    return this.c2z_1;
  };
  protoOf(RealizationCertificationCreatedEvent).h9 = function () {
    return this.d2z_1;
  };
  protoOf(RealizationCertificationCreatedEvent).d2d = function () {
    return this.e2z_1;
  };
  protoOf(RealizationCertificationCreatedEvent).g2c = function () {
    return this.f2z_1;
  };
  protoOf(RealizationCertificationCreatedEvent).s2Id = function () {
    return this.c2z_1;
  };
  protoOf(RealizationCertificationCreatedEvent).toString = function () {
    return 'RealizationCertificationCreatedEvent(id=' + this.c2z_1 + ', name=' + this.d2z_1 + ', img=' + this.e2z_1 + ', time=' + toString(this.f2z_1) + ')';
  };
  protoOf(RealizationCertificationCreatedEvent).hashCode = function () {
    var result = getStringHashCode(this.c2z_1);
    result = imul(result, 31) + getStringHashCode(this.d2z_1) | 0;
    result = imul(result, 31) + (this.e2z_1 == null ? 0 : this.e2z_1.hashCode()) | 0;
    result = imul(result, 31) + (this.f2z_1 == null ? 0 : this.f2z_1.hashCode()) | 0;
    return result;
  };
  protoOf(RealizationCertificationCreatedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RealizationCertificationCreatedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof RealizationCertificationCreatedEvent ? other : THROW_CCE();
    if (!(this.c2z_1 === tmp0_other_with_cast.c2z_1))
      return false;
    if (!(this.d2z_1 === tmp0_other_with_cast.d2z_1))
      return false;
    if (!equals(this.e2z_1, tmp0_other_with_cast.e2z_1))
      return false;
    if (!equals(this.f2z_1, tmp0_other_with_cast.f2z_1))
      return false;
    return true;
  };
  function RealizationCertificationDeleteCommandDTO() {
  }
  function RealizationCertificationDeletedEventDTO() {
  }
  function Companion_3() {
  }
  var Companion_instance_3;
  function Companion_getInstance_3() {
    return Companion_instance_3;
  }
  function $serializer_2() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.realizationCertification.domain.command.RealizationCertificationDeleteCommand', this, 1);
    tmp0_serialDesc.ht('id', false);
    this.g2z_1 = tmp0_serialDesc;
  }
  protoOf($serializer_2).ii = function () {
    return this.g2z_1;
  };
  protoOf($serializer_2).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  protoOf($serializer_2).ki = function (decoder) {
    var tmp0_desc = this.g2z_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.ul(tmp0_desc);
    if (tmp5_input.km()) {
      tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.vl(tmp0_desc);
    return RealizationCertificationDeleteCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_2).h2z = function (encoder, value) {
    var tmp0_desc = this.g2z_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.i2z_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_2).ji = function (encoder, value) {
    return this.h2z(encoder, value instanceof RealizationCertificationDeleteCommand ? value : THROW_CCE());
  };
  var $serializer_instance_2;
  function $serializer_getInstance_3() {
    if ($serializer_instance_2 == null)
      new $serializer_2();
    return $serializer_instance_2;
  }
  function RealizationCertificationDeleteCommand_init_$Init$(seen1, id, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_3().g2z_1);
    }
    $this.i2z_1 = id;
    return $this;
  }
  function RealizationCertificationDeleteCommand_init_$Create$(seen1, id, serializationConstructorMarker) {
    return RealizationCertificationDeleteCommand_init_$Init$(seen1, id, serializationConstructorMarker, objectCreate(protoOf(RealizationCertificationDeleteCommand)));
  }
  function RealizationCertificationDeleteCommand(id) {
    this.i2z_1 = id;
  }
  protoOf(RealizationCertificationDeleteCommand).k1y = function () {
    return this.i2z_1;
  };
  protoOf(RealizationCertificationDeleteCommand).toString = function () {
    return 'RealizationCertificationDeleteCommand(id=' + this.i2z_1 + ')';
  };
  protoOf(RealizationCertificationDeleteCommand).hashCode = function () {
    return getStringHashCode(this.i2z_1);
  };
  protoOf(RealizationCertificationDeleteCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RealizationCertificationDeleteCommand))
      return false;
    var tmp0_other_with_cast = other instanceof RealizationCertificationDeleteCommand ? other : THROW_CCE();
    if (!(this.i2z_1 === tmp0_other_with_cast.i2z_1))
      return false;
    return true;
  };
  function Companion_4() {
  }
  var Companion_instance_4;
  function Companion_getInstance_4() {
    return Companion_instance_4;
  }
  function $serializer_3() {
    $serializer_instance_3 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RealizationCertificationDeletedEvent', this, 2);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('time', false);
    this.j2z_1 = tmp0_serialDesc;
  }
  protoOf($serializer_3).ii = function () {
    return this.j2z_1;
  };
  protoOf($serializer_3).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance())];
  };
  protoOf($serializer_3).ki = function (decoder) {
    var tmp0_desc = this.j2z_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.ul(tmp0_desc);
    if (tmp6_input.km()) {
      tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.im(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.im(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.vl(tmp0_desc);
    return RealizationCertificationDeletedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_3).k2z = function (encoder, value) {
    var tmp0_desc = this.j2z_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.l2z_1);
    tmp1_output.nn(tmp0_desc, 1, LongSerializer_getInstance(), value.m2z_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_3).ji = function (encoder, value) {
    return this.k2z(encoder, value instanceof RealizationCertificationDeletedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_3;
  function $serializer_getInstance_4() {
    if ($serializer_instance_3 == null)
      new $serializer_3();
    return $serializer_instance_3;
  }
  function RealizationCertificationDeletedEvent_init_$Init$(seen1, id, time, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_4().j2z_1);
    }
    $this.l2z_1 = id;
    $this.m2z_1 = time;
    return $this;
  }
  function RealizationCertificationDeletedEvent_init_$Create$(seen1, id, time, serializationConstructorMarker) {
    return RealizationCertificationDeletedEvent_init_$Init$(seen1, id, time, serializationConstructorMarker, objectCreate(protoOf(RealizationCertificationDeletedEvent)));
  }
  function RealizationCertificationDeletedEvent(id, time) {
    this.l2z_1 = id;
    this.m2z_1 = time;
  }
  protoOf(RealizationCertificationDeletedEvent).k1y = function () {
    return this.l2z_1;
  };
  protoOf(RealizationCertificationDeletedEvent).g2c = function () {
    return this.m2z_1;
  };
  protoOf(RealizationCertificationDeletedEvent).s2Id = function () {
    return this.l2z_1;
  };
  protoOf(RealizationCertificationDeletedEvent).toString = function () {
    return 'RealizationCertificationDeletedEvent(id=' + this.l2z_1 + ', time=' + toString(this.m2z_1) + ')';
  };
  protoOf(RealizationCertificationDeletedEvent).hashCode = function () {
    var result = getStringHashCode(this.l2z_1);
    result = imul(result, 31) + (this.m2z_1 == null ? 0 : this.m2z_1.hashCode()) | 0;
    return result;
  };
  protoOf(RealizationCertificationDeletedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RealizationCertificationDeletedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof RealizationCertificationDeletedEvent ? other : THROW_CCE();
    if (!(this.l2z_1 === tmp0_other_with_cast.l2z_1))
      return false;
    if (!equals(this.m2z_1, tmp0_other_with_cast.m2z_1))
      return false;
    return true;
  };
  function RealizationCertificationImportCommandDTO() {
  }
  function RealizationCertificationImportedEventDTO() {
  }
  function Companion_5() {
  }
  var Companion_instance_5;
  function Companion_getInstance_5() {
    return Companion_instance_5;
  }
  function $serializer_4() {
    $serializer_instance_4 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.realizationCertification.domain.command.RealizationCertificationImportCommand', this, 1);
    tmp0_serialDesc.ht('item', false);
    this.n2z_1 = tmp0_serialDesc;
  }
  protoOf($serializer_4).ii = function () {
    return this.n2z_1;
  };
  protoOf($serializer_4).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_9()];
  };
  protoOf($serializer_4).ki = function (decoder) {
    var tmp0_desc = this.n2z_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.ul(tmp0_desc);
    if (tmp5_input.km()) {
      tmp4_local0 = tmp5_input.gm(tmp0_desc, 0, $serializer_getInstance_9(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.gm(tmp0_desc, 0, $serializer_getInstance_9(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.vl(tmp0_desc);
    return RealizationCertificationImportCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_4).o2z = function (encoder, value) {
    var tmp0_desc = this.n2z_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.ln(tmp0_desc, 0, $serializer_getInstance_9(), value.p2z_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_4).ji = function (encoder, value) {
    return this.o2z(encoder, value instanceof RealizationCertificationImportCommand ? value : THROW_CCE());
  };
  var $serializer_instance_4;
  function $serializer_getInstance_5() {
    if ($serializer_instance_4 == null)
      new $serializer_4();
    return $serializer_instance_4;
  }
  function RealizationCertificationImportCommand_init_$Init$(seen1, item, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_5().n2z_1);
    }
    $this.p2z_1 = item;
    return $this;
  }
  function RealizationCertificationImportCommand_init_$Create$(seen1, item, serializationConstructorMarker) {
    return RealizationCertificationImportCommand_init_$Init$(seen1, item, serializationConstructorMarker, objectCreate(protoOf(RealizationCertificationImportCommand)));
  }
  function RealizationCertificationImportCommand(item) {
    this.p2z_1 = item;
  }
  protoOf(RealizationCertificationImportCommand).q20 = function () {
    return this.p2z_1;
  };
  protoOf(RealizationCertificationImportCommand).toString = function () {
    return 'RealizationCertificationImportCommand(item=' + this.p2z_1 + ')';
  };
  protoOf(RealizationCertificationImportCommand).hashCode = function () {
    return this.p2z_1.hashCode();
  };
  protoOf(RealizationCertificationImportCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RealizationCertificationImportCommand))
      return false;
    var tmp0_other_with_cast = other instanceof RealizationCertificationImportCommand ? other : THROW_CCE();
    if (!this.p2z_1.equals(tmp0_other_with_cast.p2z_1))
      return false;
    return true;
  };
  function Companion_6() {
  }
  var Companion_instance_6;
  function Companion_getInstance_6() {
    return Companion_instance_6;
  }
  function $serializer_5() {
    $serializer_instance_5 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RealizationCertificationImportedEvent', this, 2);
    tmp0_serialDesc.ht('item', false);
    tmp0_serialDesc.ht('time', false);
    this.q2z_1 = tmp0_serialDesc;
  }
  protoOf($serializer_5).ii = function () {
    return this.q2z_1;
  };
  protoOf($serializer_5).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_9(), LongSerializer_getInstance()];
  };
  protoOf($serializer_5).ki = function (decoder) {
    var tmp0_desc = this.q2z_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = new Long(0, 0);
    var tmp6_input = decoder.ul(tmp0_desc);
    if (tmp6_input.km()) {
      tmp4_local0 = tmp6_input.gm(tmp0_desc, 0, $serializer_getInstance_9(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.am(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.gm(tmp0_desc, 0, $serializer_getInstance_9(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.am(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.vl(tmp0_desc);
    return RealizationCertificationImportedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_5).r2z = function (encoder, value) {
    var tmp0_desc = this.q2z_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.ln(tmp0_desc, 0, $serializer_getInstance_9(), value.s2z_1);
    tmp1_output.fn(tmp0_desc, 1, value.t2z_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_5).ji = function (encoder, value) {
    return this.r2z(encoder, value instanceof RealizationCertificationImportedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_5;
  function $serializer_getInstance_6() {
    if ($serializer_instance_5 == null)
      new $serializer_5();
    return $serializer_instance_5;
  }
  function RealizationCertificationImportedEvent_init_$Init$(seen1, item, time, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_6().q2z_1);
    }
    $this.s2z_1 = item;
    $this.t2z_1 = time;
    return $this;
  }
  function RealizationCertificationImportedEvent_init_$Create$(seen1, item, time, serializationConstructorMarker) {
    return RealizationCertificationImportedEvent_init_$Init$(seen1, item, time, serializationConstructorMarker, objectCreate(protoOf(RealizationCertificationImportedEvent)));
  }
  function RealizationCertificationImportedEvent(item, time) {
    this.s2z_1 = item;
    this.t2z_1 = time;
  }
  protoOf(RealizationCertificationImportedEvent).q20 = function () {
    return this.s2z_1;
  };
  protoOf(RealizationCertificationImportedEvent).g2c = function () {
    return this.t2z_1;
  };
  protoOf(RealizationCertificationImportedEvent).s2Id = function () {
    return this.s2z_1.u2z_1;
  };
  protoOf(RealizationCertificationImportedEvent).toString = function () {
    return 'RealizationCertificationImportedEvent(item=' + this.s2z_1 + ', time=' + this.t2z_1.toString() + ')';
  };
  protoOf(RealizationCertificationImportedEvent).hashCode = function () {
    var result = this.s2z_1.hashCode();
    result = imul(result, 31) + this.t2z_1.hashCode() | 0;
    return result;
  };
  protoOf(RealizationCertificationImportedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RealizationCertificationImportedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof RealizationCertificationImportedEvent ? other : THROW_CCE();
    if (!this.s2z_1.equals(tmp0_other_with_cast.s2z_1))
      return false;
    if (!this.t2z_1.equals(tmp0_other_with_cast.t2z_1))
      return false;
    return true;
  };
  function RealizationCertificationUpdateCommandDTO() {
  }
  function RealizationCertificationUpdatedEventDTO() {
  }
  function Companion_7() {
  }
  var Companion_instance_7;
  function Companion_getInstance_7() {
    return Companion_instance_7;
  }
  function $serializer_6() {
    $serializer_instance_6 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.realizationCertification.domain.command.RealizationCertificationUpdateCommand', this, 3);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('img', false);
    this.a30_1 = tmp0_serialDesc;
  }
  protoOf($serializer_6).ii = function () {
    return this.a30_1;
  };
  protoOf($serializer_6).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  protoOf($serializer_6).ki = function (decoder) {
    var tmp0_desc = this.a30_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.ul(tmp0_desc);
    if (tmp7_input.km()) {
      tmp4_local0 = tmp7_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.em(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.im(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.em(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.im(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.vl(tmp0_desc);
    return RealizationCertificationUpdateCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_6).b30 = function (encoder, value) {
    var tmp0_desc = this.a30_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.c30_1);
    tmp1_output.jn(tmp0_desc, 1, value.d30_1);
    tmp1_output.nn(tmp0_desc, 2, StringSerializer_getInstance(), value.e30_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_6).ji = function (encoder, value) {
    return this.b30(encoder, value instanceof RealizationCertificationUpdateCommand ? value : THROW_CCE());
  };
  var $serializer_instance_6;
  function $serializer_getInstance_7() {
    if ($serializer_instance_6 == null)
      new $serializer_6();
    return $serializer_instance_6;
  }
  function RealizationCertificationUpdateCommand_init_$Init$(seen1, id, name, img, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen1))) {
      throwMissingFieldException(seen1, 7, $serializer_getInstance_7().a30_1);
    }
    $this.c30_1 = id;
    $this.d30_1 = name;
    $this.e30_1 = img;
    return $this;
  }
  function RealizationCertificationUpdateCommand_init_$Create$(seen1, id, name, img, serializationConstructorMarker) {
    return RealizationCertificationUpdateCommand_init_$Init$(seen1, id, name, img, serializationConstructorMarker, objectCreate(protoOf(RealizationCertificationUpdateCommand)));
  }
  function RealizationCertificationUpdateCommand(id, name, img) {
    this.c30_1 = id;
    this.d30_1 = name;
    this.e30_1 = img;
  }
  protoOf(RealizationCertificationUpdateCommand).k1y = function () {
    return this.c30_1;
  };
  protoOf(RealizationCertificationUpdateCommand).h9 = function () {
    return this.d30_1;
  };
  protoOf(RealizationCertificationUpdateCommand).d2d = function () {
    return this.e30_1;
  };
  protoOf(RealizationCertificationUpdateCommand).toString = function () {
    return 'RealizationCertificationUpdateCommand(id=' + this.c30_1 + ', name=' + this.d30_1 + ', img=' + this.e30_1 + ')';
  };
  protoOf(RealizationCertificationUpdateCommand).hashCode = function () {
    var result = getStringHashCode(this.c30_1);
    result = imul(result, 31) + getStringHashCode(this.d30_1) | 0;
    result = imul(result, 31) + (this.e30_1 == null ? 0 : getStringHashCode(this.e30_1)) | 0;
    return result;
  };
  protoOf(RealizationCertificationUpdateCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RealizationCertificationUpdateCommand))
      return false;
    var tmp0_other_with_cast = other instanceof RealizationCertificationUpdateCommand ? other : THROW_CCE();
    if (!(this.c30_1 === tmp0_other_with_cast.c30_1))
      return false;
    if (!(this.d30_1 === tmp0_other_with_cast.d30_1))
      return false;
    if (!(this.e30_1 == tmp0_other_with_cast.e30_1))
      return false;
    return true;
  };
  function Companion_8() {
  }
  var Companion_instance_8;
  function Companion_getInstance_8() {
    return Companion_instance_8;
  }
  function $serializer_7() {
    $serializer_instance_7 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('RealizationCertificationUpdatedEvent', this, 4);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('img', false);
    tmp0_serialDesc.ht('time', false);
    this.f30_1 = tmp0_serialDesc;
  }
  protoOf($serializer_7).ii = function () {
    return this.f30_1;
  };
  protoOf($serializer_7).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable($serializer_getInstance()), get_nullable(LongSerializer_getInstance())];
  };
  protoOf($serializer_7).ki = function (decoder) {
    var tmp0_desc = this.f30_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.ul(tmp0_desc);
    if (tmp8_input.km()) {
      tmp4_local0 = tmp8_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.em(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.im(tmp0_desc, 2, $serializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.im(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.em(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.im(tmp0_desc, 2, $serializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.im(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.vl(tmp0_desc);
    return RealizationCertificationUpdatedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_7).g30 = function (encoder, value) {
    var tmp0_desc = this.f30_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.h30_1);
    tmp1_output.jn(tmp0_desc, 1, value.i30_1);
    tmp1_output.nn(tmp0_desc, 2, $serializer_getInstance(), value.j30_1);
    tmp1_output.nn(tmp0_desc, 3, LongSerializer_getInstance(), value.k30_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_7).ji = function (encoder, value) {
    return this.g30(encoder, value instanceof RealizationCertificationUpdatedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_7;
  function $serializer_getInstance_8() {
    if ($serializer_instance_7 == null)
      new $serializer_7();
    return $serializer_instance_7;
  }
  function RealizationCertificationUpdatedEvent_init_$Init$(seen1, id, name, img, time, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen1))) {
      throwMissingFieldException(seen1, 15, $serializer_getInstance_8().f30_1);
    }
    $this.h30_1 = id;
    $this.i30_1 = name;
    $this.j30_1 = img;
    $this.k30_1 = time;
    return $this;
  }
  function RealizationCertificationUpdatedEvent_init_$Create$(seen1, id, name, img, time, serializationConstructorMarker) {
    return RealizationCertificationUpdatedEvent_init_$Init$(seen1, id, name, img, time, serializationConstructorMarker, objectCreate(protoOf(RealizationCertificationUpdatedEvent)));
  }
  function RealizationCertificationUpdatedEvent(id, name, img, time) {
    this.h30_1 = id;
    this.i30_1 = name;
    this.j30_1 = img;
    this.k30_1 = time;
  }
  protoOf(RealizationCertificationUpdatedEvent).k1y = function () {
    return this.h30_1;
  };
  protoOf(RealizationCertificationUpdatedEvent).h9 = function () {
    return this.i30_1;
  };
  protoOf(RealizationCertificationUpdatedEvent).d2d = function () {
    return this.j30_1;
  };
  protoOf(RealizationCertificationUpdatedEvent).g2c = function () {
    return this.k30_1;
  };
  protoOf(RealizationCertificationUpdatedEvent).s2Id = function () {
    return this.h30_1;
  };
  protoOf(RealizationCertificationUpdatedEvent).toString = function () {
    return 'RealizationCertificationUpdatedEvent(id=' + this.h30_1 + ', name=' + this.i30_1 + ', img=' + this.j30_1 + ', time=' + toString(this.k30_1) + ')';
  };
  protoOf(RealizationCertificationUpdatedEvent).hashCode = function () {
    var result = getStringHashCode(this.h30_1);
    result = imul(result, 31) + getStringHashCode(this.i30_1) | 0;
    result = imul(result, 31) + (this.j30_1 == null ? 0 : this.j30_1.hashCode()) | 0;
    result = imul(result, 31) + (this.k30_1 == null ? 0 : this.k30_1.hashCode()) | 0;
    return result;
  };
  protoOf(RealizationCertificationUpdatedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RealizationCertificationUpdatedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof RealizationCertificationUpdatedEvent ? other : THROW_CCE();
    if (!(this.h30_1 === tmp0_other_with_cast.h30_1))
      return false;
    if (!(this.i30_1 === tmp0_other_with_cast.i30_1))
      return false;
    if (!equals(this.j30_1, tmp0_other_with_cast.j30_1))
      return false;
    if (!equals(this.k30_1, tmp0_other_with_cast.k30_1))
      return false;
    return true;
  };
  function RealizationCertificationModelDTO() {
  }
  function Companion_9() {
    Companion_instance_9 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l30_1 = [null, Companion_getInstance().x14(), null, null, null, null];
  }
  var Companion_instance_9;
  function Companion_getInstance_9() {
    if (Companion_instance_9 == null)
      new Companion_9();
    return Companion_instance_9;
  }
  function $serializer_8() {
    $serializer_instance_8 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.realizationCertification.domain.model.RealizationCertificationModel', this, 6);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('status', false);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('img', false);
    tmp0_serialDesc.ht('creationDate', false);
    tmp0_serialDesc.ht('updatedDate', false);
    this.m30_1 = tmp0_serialDesc;
  }
  protoOf($serializer_8).ii = function () {
    return this.m30_1;
  };
  protoOf($serializer_8).wt = function () {
    var tmp0_cached = Companion_getInstance_9().l30_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), tmp0_cached[1], StringSerializer_getInstance(), get_nullable($serializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance())];
  };
  protoOf($serializer_8).ki = function (decoder) {
    var tmp0_desc = this.m30_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_input = decoder.ul(tmp0_desc);
    var tmp11_cached = Companion_getInstance_9().l30_1;
    if (tmp10_input.km()) {
      tmp4_local0 = tmp10_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.gm(tmp0_desc, 1, tmp11_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.em(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.im(tmp0_desc, 3, $serializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.im(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.im(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.gm(tmp0_desc, 1, tmp11_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.em(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.im(tmp0_desc, 3, $serializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.im(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.im(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.vl(tmp0_desc);
    return RealizationCertificationModel_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer_8).n30 = function (encoder, value) {
    var tmp0_desc = this.m30_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_9().l30_1;
    tmp1_output.jn(tmp0_desc, 0, value.u2z_1);
    tmp1_output.ln(tmp0_desc, 1, tmp2_cached[1], value.v2z_1);
    tmp1_output.jn(tmp0_desc, 2, value.w2z_1);
    tmp1_output.nn(tmp0_desc, 3, $serializer_getInstance(), value.x2z_1);
    tmp1_output.nn(tmp0_desc, 4, LongSerializer_getInstance(), value.y2z_1);
    tmp1_output.nn(tmp0_desc, 5, LongSerializer_getInstance(), value.z2z_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_8).ji = function (encoder, value) {
    return this.n30(encoder, value instanceof RealizationCertificationModel ? value : THROW_CCE());
  };
  var $serializer_instance_8;
  function $serializer_getInstance_9() {
    if ($serializer_instance_8 == null)
      new $serializer_8();
    return $serializer_instance_8;
  }
  function RealizationCertificationModel_init_$Init$(seen1, id, status, name, img, creationDate, updatedDate, serializationConstructorMarker, $this) {
    if (!(63 === (63 & seen1))) {
      throwMissingFieldException(seen1, 63, $serializer_getInstance_9().m30_1);
    }
    $this.u2z_1 = id;
    $this.v2z_1 = status;
    $this.w2z_1 = name;
    $this.x2z_1 = img;
    $this.y2z_1 = creationDate;
    $this.z2z_1 = updatedDate;
    return $this;
  }
  function RealizationCertificationModel_init_$Create$(seen1, id, status, name, img, creationDate, updatedDate, serializationConstructorMarker) {
    return RealizationCertificationModel_init_$Init$(seen1, id, status, name, img, creationDate, updatedDate, serializationConstructorMarker, objectCreate(protoOf(RealizationCertificationModel)));
  }
  function RealizationCertificationModel() {
  }
  protoOf(RealizationCertificationModel).k1y = function () {
    return this.u2z_1;
  };
  protoOf(RealizationCertificationModel).y2f = function () {
    return this.v2z_1;
  };
  protoOf(RealizationCertificationModel).h9 = function () {
    return this.w2z_1;
  };
  protoOf(RealizationCertificationModel).d2d = function () {
    return this.x2z_1;
  };
  protoOf(RealizationCertificationModel).v2h = function () {
    return this.y2z_1;
  };
  protoOf(RealizationCertificationModel).w2h = function () {
    return this.z2z_1;
  };
  protoOf(RealizationCertificationModel).s2State = function () {
    return this.v2z_1;
  };
  protoOf(RealizationCertificationModel).s2Id = function () {
    return this.u2z_1;
  };
  protoOf(RealizationCertificationModel).toString = function () {
    return 'RealizationCertificationModel(id=' + this.u2z_1 + ', status=' + this.v2z_1 + ', name=' + this.w2z_1 + ', img=' + this.x2z_1 + ', creationDate=' + toString(this.y2z_1) + ', updatedDate=' + toString(this.z2z_1) + ')';
  };
  protoOf(RealizationCertificationModel).hashCode = function () {
    var result = getStringHashCode(this.u2z_1);
    result = imul(result, 31) + this.v2z_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.w2z_1) | 0;
    result = imul(result, 31) + (this.x2z_1 == null ? 0 : this.x2z_1.hashCode()) | 0;
    result = imul(result, 31) + (this.y2z_1 == null ? 0 : this.y2z_1.hashCode()) | 0;
    result = imul(result, 31) + (this.z2z_1 == null ? 0 : this.z2z_1.hashCode()) | 0;
    return result;
  };
  protoOf(RealizationCertificationModel).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RealizationCertificationModel))
      return false;
    var tmp0_other_with_cast = other instanceof RealizationCertificationModel ? other : THROW_CCE();
    if (!(this.u2z_1 === tmp0_other_with_cast.u2z_1))
      return false;
    if (!this.v2z_1.equals(tmp0_other_with_cast.v2z_1))
      return false;
    if (!(this.w2z_1 === tmp0_other_with_cast.w2z_1))
      return false;
    if (!equals(this.x2z_1, tmp0_other_with_cast.x2z_1))
      return false;
    if (!equals(this.y2z_1, tmp0_other_with_cast.y2z_1))
      return false;
    if (!equals(this.z2z_1, tmp0_other_with_cast.z2z_1))
      return false;
    return true;
  };
  function RealizationCertificationPolicies() {
  }
  protoOf(RealizationCertificationPolicies).canPage = function (authedUser) {
    return true;
  };
  protoOf(RealizationCertificationPolicies).canGet = function (authedUser) {
    return true;
  };
  protoOf(RealizationCertificationPolicies).canCreate = function (authedUser) {
    return hasRole(authedUser, 'Marque');
  };
  protoOf(RealizationCertificationPolicies).canUpdate = function (authedUser, target) {
    // Inline function 'org.boislocal.platform.s2.commons.domain.model.canExecuteTransitionAnd' call
    var this_0 = S2_getInstance().s2y_1;
    var tmp;
    if (isAvailableTransition(this_0, target, ensureNotNull(getKClass(RealizationCertificationUpdateCommand).z5()))) {
      // Inline function 'org.boislocal.platform.s2.realizationCertification.domain.policy.RealizationCertificationPolicies.canUpdate.<anonymous>' call
      tmp = hasRole(authedUser, 'Marque');
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(RealizationCertificationPolicies).canDelete = function (authedUser, target) {
    // Inline function 'org.boislocal.platform.s2.commons.domain.model.canExecuteTransitionAnd' call
    var this_0 = S2_getInstance().s2y_1;
    var tmp;
    if (isAvailableTransition(this_0, target, ensureNotNull(getKClass(RealizationCertificationDeleteCommand).z5()))) {
      // Inline function 'org.boislocal.platform.s2.realizationCertification.domain.policy.RealizationCertificationPolicies.canDelete.<anonymous>' call
      tmp = hasRole(authedUser, 'Marque');
    } else {
      tmp = false;
    }
    return tmp;
  };
  var RealizationCertificationPolicies_instance;
  function RealizationCertificationPolicies_getInstance() {
    return RealizationCertificationPolicies_instance;
  }
  function RealizationCertificationGetQueryDTO() {
  }
  function RealizationCertificationGetResponseDTO() {
  }
  function RealizationCertificationPageQueryDTO() {
  }
  function RealizationCertificationPageResponseDTO() {
  }
  //region block: post-declaration
  defineProp(protoOf(RealizationCertificationState), 'position', function () {
    return this.jr();
  }, function (value) {
    this.y2c(value);
  });
  defineProp(protoOf(RealizationCertificationState), 'name', protoOf(RealizationCertificationState).h9);
  defineProp(protoOf(RealizationCertificationState), 'ordinal', protoOf(RealizationCertificationState).i9);
  protoOf($serializer).xt = typeParametersSerializers;
  protoOf($serializer_0).xt = typeParametersSerializers;
  defineProp(protoOf(RealizationCertificationCreateCommand), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(RealizationCertificationCreateCommand), 'img', function () {
    return this.d2d();
  });
  protoOf($serializer_1).xt = typeParametersSerializers;
  defineProp(protoOf(RealizationCertificationCreatedEvent), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(RealizationCertificationCreatedEvent), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(RealizationCertificationCreatedEvent), 'img', function () {
    return this.d2d();
  });
  defineProp(protoOf(RealizationCertificationCreatedEvent), 'time');
  protoOf($serializer_2).xt = typeParametersSerializers;
  defineProp(protoOf(RealizationCertificationDeleteCommand), 'id', function () {
    return this.k1y();
  });
  protoOf($serializer_3).xt = typeParametersSerializers;
  defineProp(protoOf(RealizationCertificationDeletedEvent), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(RealizationCertificationDeletedEvent), 'time');
  protoOf($serializer_4).xt = typeParametersSerializers;
  defineProp(protoOf(RealizationCertificationImportCommand), 'item', function () {
    return this.q20();
  });
  protoOf($serializer_5).xt = typeParametersSerializers;
  defineProp(protoOf(RealizationCertificationImportedEvent), 'item', function () {
    return this.q20();
  });
  defineProp(protoOf(RealizationCertificationImportedEvent), 'time');
  protoOf($serializer_6).xt = typeParametersSerializers;
  defineProp(protoOf(RealizationCertificationUpdateCommand), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(RealizationCertificationUpdateCommand), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(RealizationCertificationUpdateCommand), 'img', function () {
    return this.d2d();
  });
  protoOf($serializer_7).xt = typeParametersSerializers;
  defineProp(protoOf(RealizationCertificationUpdatedEvent), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(RealizationCertificationUpdatedEvent), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(RealizationCertificationUpdatedEvent), 'img', function () {
    return this.d2d();
  });
  defineProp(protoOf(RealizationCertificationUpdatedEvent), 'time');
  protoOf($serializer_8).xt = typeParametersSerializers;
  defineProp(protoOf(RealizationCertificationModel), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(RealizationCertificationModel), 'status', function () {
    return this.y2f();
  });
  defineProp(protoOf(RealizationCertificationModel), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(RealizationCertificationModel), 'img', function () {
    return this.d2d();
  });
  defineProp(protoOf(RealizationCertificationModel), 'creationDate', function () {
    return this.v2h();
  });
  defineProp(protoOf(RealizationCertificationModel), 'updatedDate', function () {
    return this.w2h();
  });
  //endregion
  //region block: init
  Companion_instance_0 = new Companion_0();
  Companion_instance_1 = new Companion_1();
  Companion_instance_2 = new Companion_2();
  Companion_instance_3 = new Companion_3();
  Companion_instance_4 = new Companion_4();
  Companion_instance_5 = new Companion_5();
  Companion_instance_6 = new Companion_6();
  Companion_instance_7 = new Companion_7();
  Companion_instance_8 = new Companion_8();
  RealizationCertificationPolicies_instance = new RealizationCertificationPolicies();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$realizationCertification = $org$boislocal$platform$s2.realizationCertification || ($org$boislocal$platform$s2.realizationCertification = {});
    var $org$boislocal$platform$s2$realizationCertification$domain = $org$boislocal$platform$s2$realizationCertification.domain || ($org$boislocal$platform$s2$realizationCertification.domain = {});
    var $org$boislocal$platform$s2$realizationCertification$domain$automate = $org$boislocal$platform$s2$realizationCertification$domain.automate || ($org$boislocal$platform$s2$realizationCertification$domain.automate = {});
    $org$boislocal$platform$s2$realizationCertification$domain$automate.RealizationCertificationState = RealizationCertificationState;
    $org$boislocal$platform$s2$realizationCertification$domain$automate.RealizationCertificationState.values = values;
    $org$boislocal$platform$s2$realizationCertification$domain$automate.RealizationCertificationState.valueOf = valueOf;
    defineProp($org$boislocal$platform$s2$realizationCertification$domain$automate.RealizationCertificationState, 'Exists', RealizationCertificationState_Exists_getInstance);
    defineProp($org$boislocal$platform$s2$realizationCertification$domain$automate.RealizationCertificationState, 'Deleted', RealizationCertificationState_Deleted_getInstance);
    defineProp($org$boislocal$platform$s2$realizationCertification$domain$automate.RealizationCertificationState, 'Companion', Companion_getInstance);
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$realizationCertification = $org$boislocal$platform$s2.realizationCertification || ($org$boislocal$platform$s2.realizationCertification = {});
    var $org$boislocal$platform$s2$realizationCertification$domain = $org$boislocal$platform$s2$realizationCertification.domain || ($org$boislocal$platform$s2$realizationCertification.domain = {});
    var $org$boislocal$platform$s2$realizationCertification$domain$command = $org$boislocal$platform$s2$realizationCertification$domain.command || ($org$boislocal$platform$s2$realizationCertification$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$realizationCertification = $org$boislocal$platform$s2.realizationCertification || ($org$boislocal$platform$s2.realizationCertification = {});
    var $org$boislocal$platform$s2$realizationCertification$domain = $org$boislocal$platform$s2$realizationCertification.domain || ($org$boislocal$platform$s2$realizationCertification.domain = {});
    var $org$boislocal$platform$s2$realizationCertification$domain$command = $org$boislocal$platform$s2$realizationCertification$domain.command || ($org$boislocal$platform$s2$realizationCertification$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$realizationCertification = $org$boislocal$platform$s2.realizationCertification || ($org$boislocal$platform$s2.realizationCertification = {});
    var $org$boislocal$platform$s2$realizationCertification$domain = $org$boislocal$platform$s2$realizationCertification.domain || ($org$boislocal$platform$s2$realizationCertification.domain = {});
    var $org$boislocal$platform$s2$realizationCertification$domain$command = $org$boislocal$platform$s2$realizationCertification$domain.command || ($org$boislocal$platform$s2$realizationCertification$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$realizationCertification = $org$boislocal$platform$s2.realizationCertification || ($org$boislocal$platform$s2.realizationCertification = {});
    var $org$boislocal$platform$s2$realizationCertification$domain = $org$boislocal$platform$s2$realizationCertification.domain || ($org$boislocal$platform$s2$realizationCertification.domain = {});
    var $org$boislocal$platform$s2$realizationCertification$domain$command = $org$boislocal$platform$s2$realizationCertification$domain.command || ($org$boislocal$platform$s2$realizationCertification$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$realizationCertification = $org$boislocal$platform$s2.realizationCertification || ($org$boislocal$platform$s2.realizationCertification = {});
    var $org$boislocal$platform$s2$realizationCertification$domain = $org$boislocal$platform$s2$realizationCertification.domain || ($org$boislocal$platform$s2$realizationCertification.domain = {});
    var $org$boislocal$platform$s2$realizationCertification$domain$model = $org$boislocal$platform$s2$realizationCertification$domain.model || ($org$boislocal$platform$s2$realizationCertification$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$realizationCertification = $org$boislocal$platform$s2.realizationCertification || ($org$boislocal$platform$s2.realizationCertification = {});
    var $org$boislocal$platform$s2$realizationCertification$domain = $org$boislocal$platform$s2$realizationCertification.domain || ($org$boislocal$platform$s2$realizationCertification.domain = {});
    var $org$boislocal$platform$s2$realizationCertification$domain$policy = $org$boislocal$platform$s2$realizationCertification$domain.policy || ($org$boislocal$platform$s2$realizationCertification$domain.policy = {});
    defineProp($org$boislocal$platform$s2$realizationCertification$domain$policy, 'RealizationCertificationPolicies', RealizationCertificationPolicies_getInstance);
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$realizationCertification = $org$boislocal$platform$s2.realizationCertification || ($org$boislocal$platform$s2.realizationCertification = {});
    var $org$boislocal$platform$s2$realizationCertification$domain = $org$boislocal$platform$s2$realizationCertification.domain || ($org$boislocal$platform$s2$realizationCertification.domain = {});
    var $org$boislocal$platform$s2$realizationCertification$domain$query = $org$boislocal$platform$s2$realizationCertification$domain.query || ($org$boislocal$platform$s2$realizationCertification$domain.query = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$realizationCertification = $org$boislocal$platform$s2.realizationCertification || ($org$boislocal$platform$s2.realizationCertification = {});
    var $org$boislocal$platform$s2$realizationCertification$domain = $org$boislocal$platform$s2$realizationCertification.domain || ($org$boislocal$platform$s2$realizationCertification.domain = {});
    var $org$boislocal$platform$s2$realizationCertification$domain$query = $org$boislocal$platform$s2$realizationCertification$domain.query || ($org$boislocal$platform$s2$realizationCertification$domain.query = {});
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  _.$_$ = _.$_$ || {};
  _.$_$.a = $serializer_getInstance_9;
  //endregion
  return _;
}));

//# sourceMappingURL=boislocal-platform-platform-s2-referential-realizationCertification-realizationCertification-domain.js.map
